import { render } from "./CorrectFangAnView.vue?vue&type=template&id=50fc413b&scoped=true&ts=true"
import script from "./CorrectFangAnView.vue?vue&type=script&lang=ts"
export * from "./CorrectFangAnView.vue?vue&type=script&lang=ts"

import "./CorrectFangAnView.vue?vue&type=style&index=0&id=50fc413b&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fc413b"]])

export default __exports__